import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Form from '@nmx/template/dist/componentLibrary/components/forms/Form';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Loading from '@nmx/template/dist/componentLibrary/components/Loading';

export const LoadingStyled = styled(Loading)`
  ${({ theme }) => css`
      margin-top: ${rem(40)};
      .loader {
        &::before {
          border-bottom-color: ${theme.colors.sky.sky}; /** light-theme loader, will be building darkTheme into nmx-template */
          border-left-color: ${theme.colors.sky.sky}; /** light-theme loader, will be building darkTheme into nmx-template */
        }
      }
  `};
`;

export const FieldsetStyled = styled.fieldset`
  padding: 0;
`;

export const FormStyled = styled(Form)`
  > .nmx-container {
    padding: 0;
  }
`;

export const LegendStyled = styled.legend`
  display: none;
`;

export const LinkStyled = styled(Link)`
  display: block;
  margin-bottom: ${rem(16)};
`;

export const ULStyled = styled.ul`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(16) : rem(24)};
      margin-top: ${rem(30)};
    `;
  }
}`;
